/*
 * File: CoreUI-White.ts
 * File Created: 2023-12-13 10:10:45
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2026-02-23 14:47:08
 * Modified By: Val Liu <valuis0429@gmail.com>
 * -----
 */

import { Component } from "vue-property-decorator";
import packageJson from "@/package.json";
// import LanguageModal from "@/components/modals/language-modal/language-modal.vue";
// import ChangePasswordModal from "@/components/modals/change-password-modal/change-password-modal.vue";
import { BaseComponent, BaseView } from "@root/components";
import config from "@/config/default/debug.js";
import appConfig from "@/config/default/application";

@Component
export class BaseTheme extends BaseView {
    title: string = packageJson.description;
    config = config;

    get userName(): string {
        const _ = (this as any).$permissionsVersion;
        const user = (this as any).$user ?? {};
        return user.name || user.username || user.email || this.$_("w_User");
    }

    get userInitial(): string {
        const name = this.userName || "";
        return name.trim().charAt(0).toUpperCase() || "?";
    }

    get supportEmailHref(): string {
        const email = appConfig.supportEmail || "";
        return email ? `mailto:${email}` : "mailto:";
    }

    async doLogout() {
        await this.$logout();
        this.$router.push("//");
    }
}
export default BaseTheme;
